import { Router } from "react-router-dom";
import { useRef, useState, useLayoutEffect } from "react";
import { createBrowserHistory } from "history";

export const customHistory = createBrowserHistory();

export const lastPathsRef = { current: [] };

export function CustomBrowserRouter({ basename, children }) {
  const history = useRef(customHistory).current;
  const [state, setState] = useState({
    action: history.action,
    location: history.location,
  });

  useLayoutEffect(() => {
    return history.listen(({ location, action }) => {
      setState({ location, action });

      const arr = lastPathsRef.current;
      const next = location.pathname;

      if (arr[arr.length - 1] !== next) {
        arr.push(next);
        if (arr.length > 10) arr.shift();
      }
    });
  }, [history]);

  return (
    <Router
      basename={basename}
      children={children}
      location={state.location}
      navigationType={state.action}
      navigator={history}
    />
  );
}
